import { FC } from 'react';
import { AutoFillGenericModal, AutoFillGenericModalTexts, OnSaveAutoFill } from 'components/auto-fill-generic';
import { PRESIGNED_UPLOAD_USE_CASE } from 'constants/common';

const ESTIMATE_MODAL_TEXTS: AutoFillGenericModalTexts = {
  title: 'AI estimate autofill',
  description: 'Upload a document or add notes to fill your estimate',
  instructionsLabel: 'Need to add instructions ? (Optional)',
  instructionsPlaceholder:
    // eslint-disable-next-line quotes
    "Tell us anything important… e.g., 'use the PDF for prices', 'tax included'. You can also paste an image.",
  loadingTitle: 'Filling your estimate',
  successMessage: 'Estimate details auto-filled successfully!'
};

interface EstimateAutoFillModalProps {
  onSave: OnSaveAutoFill;
  isSaving: boolean;
  isOpen: boolean;
  onClose: () => void;
}

const EstimateAutoFillModal: FC<EstimateAutoFillModalProps> = ({ onSave, isSaving, isOpen, onClose }) => {
  return (
    <AutoFillGenericModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      texts={ESTIMATE_MODAL_TEXTS}
      enableFileUpload={true}
      uploadUseCase={PRESIGNED_UPLOAD_USE_CASE.ESTIMATE_AUTO_FILL}
      maxTextLength={1000}
      showTextAreaCharCount={true}
    />
  );
};

export default EstimateAutoFillModal;
